import { createActions, createReducer } from "reduxsauce";

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
  addConfigs: ["config"],
  addConfig: ["config"],
  editConfig: ["id","config"],
  removeConfig: ["id"]
});

/**
 * Implementação das manipulações do State
 */
const INITIAL_STATE = [];

const addConfig = (state = INITIAL_STATE, action) => action.config;


const add = (state = INITIAL_STATE, action) => [
  ...state, action.config
]  
  
const edit = (state = INITIAL_STATE, action) => (
  state.map(item => {
    if (item.id == action.id) {
      return action.config;
    } else {
     return item;
    }
  })
);

const remove = (state = INITIAL_STATE, action) =>
  state.filter(todo => todo.id !== action.id);

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
  [Types.ADD_CONFIGS]: addConfig,
  [Types.ADD_CONFIG]: add,
  [Types.EDIT_CONFIG]: edit,
  [Types.REMOVE_CONFIG]: remove
});
